export const reasonCodeBasedOnPriority = {
  // High priority
  123: "High",
  12301: "High",
  12302: "High",
  12303: "High",
  12304: "High",
  12305: "High",
  12306: "High",
  127: "High",
  129: "High",
  131: "High",
  133: "High",
  137: "High",
  143: "High",
  145: "High",
  157: "High",
  163: "High",
  165: "High",
  179: "High",
  181: "High",
  18101: "High",
  182: "High",
  18206: "High",
  19001: "High",
  19901: "High",
  19903: "High",
  234: "High",
  23401: "High",
  23402: "High",
  23501: "High",
  345: "High",
  42301: "High",
  456: "High",
  567: "High",
  56701: "High",
  56702: "High",
  56703: "High",
  678: "High",
  891: "High",
  912: "High",
  52905: "High",

  // Low priority
  125: "Low",
  135: "Low",
  139: "Low",
  141: "Low",
  147: "Low",
  149: "Low",
  151: "Low",
  153: "Low",
  155: "Low",
  159: "Low",
  161: "Low",
  167: "Low",
  169: "Low",
  171: "Low",
  173: "Low",
  175: "Low",
  177: "Low",
  180: "Low",
  18001: "Low",
  183: "Low",
  18301: "Low",
  34501: "Low",
  67801: "Low",
  789: "Low",
  78901: "Low",
  78902: "Low",
  78903: "Low",
  78904: "Low",
  91201: "Low",
  12307: "Low",
  12308: "Low",
  12309: "Low",
  12310: "Low",
  12311: "Low",
  12312: "Low",
  12313: "Low",
  12314: "Low",
  18201: "Low",
  18202: "Low",
  18203: "Low",
  18204: "Low",
  18205: "Low",
  52901: "Low",

  // Blank priority
  "000": "",
  12212: "",
  12213: "",
  12214: "",
  12215: "",
  12216: "",
  12217: "",
  12218: "",
  12219: "",
  12220: "",
  12221: "",
  12222: "",
  12223: "",
  12224: "",
  12225: "",
  12226: "",
  12228: "",
  12229: "",
  12230: "",
  12231: "",
  12232: "",
  12234: "",
  12235: "",
  12236: "",
  12237: "",
  12238: "",
  12239: "",
};

export const reasonCodeToKeyPriority = {
  // High Priority
  TM: "High",
  MRP: "High",
  Fake: "High",
  Compliance: "High",
  Design: "High",
  Extensions: "High",
  Combo: "High",
  Tradedress: "High",
  AuthorIncorrect: "High",
  AuthorMissing: "High",
  BookCoverDiff: "High",
  DiscountHigh: "High",
  ISBNIncorrect: "High",
  ISBNMissing: "High",
  MRPHigh: "High",
  "PriceDiffMoreThan30%": "High",
  PublisherDiff: "High",
  MRPLow: "High",
  D2C: "High",
  Lookalike: "High",

  TM_Title: "High",
  TM_Description: "High",
  TM_StyleCode: "High",
  TM_ModelNumber: "High",
  TM_BrandColor: "High",
  TM_SalesPackage: "High",
  D2C_NotAllowed: "High",
  MRP_Discount80: "High",
  MRP_Higher30: "High",
  MRP_Lower30: "High",
  Fake_TM_MRP: "High",
  Fake_ImageEdited: "High",
  Lookalike_CopyrightImageUse: "High",
  Lookalike_Image: "High",
  Unauth_Seller: "High",
  Photoshopped_BrandRemovedOrDistorted: "High",
  Sale_Mentioned: "High",
  Old_Edition: "High",

  // Low Priority
  Import: "Low",
  AuthorDiff: "Low",
  Counterfeit: "Low",
  EditionWrong: "Low",
  Error: "Low",
  LanguageDiff: "Low",
  ManPackDiff: "Low",
  ManPackIncorrect: "Low",
  ManPackMissing: "Low",
  MonthDiff: "Low",
  NotAnInfgmnt: "Low",
  PagesDiff: "Low",
  PublisherMissing: "Low",
  SpecificationDiff: "Low",
  TitleIncorrect: "Low",
  YearDiff: "Low",
  YearMissing: "Low",
  BindingDiff: "Low",
  Expired: "Low",
  Mismatch: "Low",

  TM_Title_WrongSpelling: "Low",
  TM_Description_WrongSpelling: "Low",
  TM_StyleCode_WrongSpelling: "Low",
  TM_ModelNumber_WrongSpelling: "Low",
  TM_SalesPackage_WrongSpelling: "Low",
  TM_LogoButMissingBrandName: "Low",
  TM_Misspelled_GenuinePackaging: "Low",
  TM_LogoButMissingBrandInTitle: "Low",
  Lookalike_MisspelledBrand: "Low",
  Lookalike_EditedBrand: "Low",
  Lookalike_RemovedBrand: "Low",
  Lookalike_SimilarPackaging: "Low",
  Design_SimilarDesign: "Low",
  Import_Language: "Low",
  Import_ImportWord: "Low",
  Import_NotOnIndianPlatform: "Low",
  Import_NoImportLicensee: "Low",
  RangeExtension_DiffTMClass: "Low",
  Combo_Branded: "Low",
  Expired_PastDate: "Low",
  Mismatch_BrandNotFirstWordinTitle: "Low",
  Mismatch_TitleImageCount: "Low",

  // Blank Priority
  NotApplicable: "",
  Sponsored_Listing: "",
  Misleading_Pricing_Information: "",
  Missing_Partnership_Logo: "",
  Unauthorized_Image_Used: "",
  Incorrect_Customer_Care_Number: "",
  Unauthorized_Partnership_Reference: "",
  Phishing_Activity: "",
  Domain_Redirection: "",
  Phishing_Emails: "",
  "No._Of_Views_Increased": "",
  Logo_Appeared: "",
  Brand_Name_In_The_Title: "",
  Logo_But_Missing_Brand_In_Title: "",
  Content_Protected_Under_Free_Speech: "",
  Influencer_Promoting_Fake_Products: "",
  Misleading_Brand_Association: "",
  "No._Of_Followers_Increased": "",
  "No._Of_Likes_Increased": "",
  Brand_Name_Misspelled: "",
  Contains_Brand_Unique_Number: "",
  "Auto-Download_on_URL_Access": "",
  Brand_Logo_Used: "",
  Available_on_Unauthorized_App_Stores: "",
  Brand_Name_On_The_Website: "",
};
